<template>
  <div class="lp-radio-group-outer">
    <span v-if="labelTop" class="lp-input-label font-weight-medium">
      <slot name="label-top" :props="props">
        <span>{{ labelTop }}</span>
        <span v-if="required" class="text-blue">*</span>
      </slot>
    </span>
    <div
      class="lp-radio-group-wrapper"
      :class="[
        direction === 'horizontal' ? 'ly-row' : 'ly-col',
        even && 'ly-even',
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'lp-radio-group',
})

interface Props {
  required?: boolean
  even?: boolean
  labelTop?: string | null
  direction?: 'vertical' | 'horizontal'
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
  even: false,
  labelTop: null,
  direction: 'vertical',
})
</script>
